import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { HeaderTemplate, KeyValue } from 'web-library';
import { selectCandidateResitRegistration } from '../../store/resitSlice';

const ExamLevelKeyValue = () => {
  const { t } = useTranslation();

  const examRedux = useSelector(selectCandidateResitRegistration);

  return (
    <HeaderTemplate>
      <KeyValue
        keyText={t('resit-->CoordinatorResit.Examination')}
        valueText={`${examRedux.examLevel?.description || ''} ${dayjs().year()}`}
      />
    </HeaderTemplate>
  );
};

export default ExamLevelKeyValue;
